import React, { useState } from "react";
import PropTypes from "prop-types";
import { DataTableProvider } from "components/DataTable";
import { PAGINATION_TYPE } from "components/Pagination";
import { FormattedMessage } from "react-intl";
import { PrimaryLink } from "components/Links";
import Modal, { MODAL_SIZE } from "components/Modal";
import { ICON_SIZE, ICON_TYPE, withIcon } from "components/Icon";
import { UserFullName } from "components/User";

/**
 * QuestionsList
 *
 * @param {Array}     data
 * @param {Boolean}   loading
 * @param {Number}    resultsPerPage
 */
const RoleAttachmentsList = ({ data, loading, resultsPerPage, ...props }) => {
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  return (
    <>
      <DataTableProvider
        loading={loading}
        data={data}
        resultsPerPage={resultsPerPage}
        columns={COLUMN_DATA(setSelectedAttachment)}
        paginationType={PAGINATION_TYPE.classic}
        paginationProps={{
          countMessage: "Global.Questions.Count",
        }}
        {...props}
      />
      <Modal
        show={!!selectedAttachment}
        size={MODAL_SIZE.large}
        title={<FormattedMessage id="RoleAttachments.AttachmentsList.Title" />}
        onClose={() => setSelectedAttachment(null)}
        showSave={false}
        showCancel={true}
        secondaryButtonMessageId="Global.Close"
      >
        <iframe src={`${selectedAttachment?.url}#toolbar=0`} width="100%" height={500} />
      </Modal>
    </>
  );
};

const COLUMN_DATA = (handleClick) => [
  {
    label: <FormattedMessage id="RoleAttachments.AttachmentsList.FileDetails" />,
    cell: (attachment) => <ViewResumeLink onClick={() => handleClick(attachment)}>{attachment?.name}</ViewResumeLink>,
    width: "80%",
  },
  {
    label: <FormattedMessage id="RoleAttachments.AttachmentsList.AddedBy" />,
    cell: (attachment) => <UserFullName data={attachment?.uploadedBy} />,
    width: "20%",
  },
];

const ViewResumeLink = withIcon(PrimaryLink, {
  type: ICON_TYPE.file,
  size: ICON_SIZE.xlarge,
  color: "inherit",
});

RoleAttachmentsList.defaultProps = {
  resultsPerPage: 20,
  data: [],
};

RoleAttachmentsList.propTypes = {
  resultsPerPage: PropTypes.number,
  loading: PropTypes.bool,
  data: PropTypes.array,
};

export default RoleAttachmentsList;
